import { useLocale } from "../i18n";
import type { FacilityNode } from "./types";

export function inactiveFacilityParent(parent?: FacilityNode) {
  return parent && [parent, ...(parent.ancestors || [])].find(node => node.state !== "ACTIVE");
}

export function FacilityParentWarning({ parent }: { parent?: FacilityNode }) {
  const { w } = useLocale();
  const inactive = inactiveFacilityParent(parent);
  if (!inactive) return null;
  return <p role="alert" className="facility-feedback">
    {w(`لا يمكن إضافة مرفق فرعي لأن «${inactive.name}» غير نشط. افتح تعديل هذا المرفق وغيّر حالته إلى «نشط» ثم احفظ، أو اختر مرفقاً أباً نشطاً.`, `Cannot add a child facility because “${inactive.name}” is inactive. Edit that facility, set its state to Active and save, or choose an active parent.`)}
  </p>;
}
